import type { JSX } from 'react';

import { SingleSelect } from '../Inputs/SingleSelect';

import {
  EMAIL_SCOPE_OPTIONS,
  EMAIL_SCOPE_TITLE,
  isEmailNotificationScope,
  useEmailNotificationScope,
} from './emailNotificationScope';

/**
 * Which incoming email puts a notification in the bell, as a select. The bell
 * panel offers the same choice as a radio group; this is for pages (the phone
 * notifications page, the Account page).
 */
export function EmailNotificationScopeSelect({
  id,
  className,
}: {
  id?: string;
  className?: string;
}): JSX.Element {
  const { scope, loaded, saving, setScope } = useEmailNotificationScope();
  return (
    <SingleSelect
      id={id}
      className={className}
      aria-label={EMAIL_SCOPE_TITLE}
      options={EMAIL_SCOPE_OPTIONS}
      value={scope}
      loading={!loaded}
      disabled={!loaded || saving}
      onChange={(value) => {
        if (isEmailNotificationScope(value) && value !== scope) setScope(value);
      }}
    />
  );
}
